import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import {
  BookingWizardDataAtom,
  currentDurationOptionsAtom,
} from "../../stores";

export const setDurationAtom = atom(
  null,
  (get, set, { durationMins }: { durationMins: number }) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (!bookingWizardData || bookingWizardData.type !== "DurationBooking") {
      //@TODO: this is an error
      return;
    }

    const currentValidDurationOptions = get(currentDurationOptionsAtom);
    const currentGroupSize = bookingWizardData.groupSize ?? 0;

    const newBookingWizardData: BookingWizard.DurationBookingWizardData = {
      ...bookingWizardData,
      durationMins,
    };

    /**
     * If we have chosen a duration that does not work on our current course
     * with our current group size -- we clear our course selection and require
     * the user to select one of the valid options (or change their seleciton)
     */
    const durationOptionsForCurrentCourse = currentValidDurationOptions.find(
      (duration) => duration.courseId === bookingWizardData.courseId
    );
    const isCurrentDurationValidOnCurrentCourse =
      durationOptionsForCurrentCourse?.endSlotOptions?.find(
        (duration) =>
          duration.durationMins === durationMins &&
          duration.allowedPlayerCounts?.includes(currentGroupSize)
      );

    if (
      !!bookingWizardData.courseId &&
      !isCurrentDurationValidOnCurrentCourse
    ) {
      newBookingWizardData.courseId = null;
      newBookingWizardData.startSlotId = null;
    }

    set(BookingWizardDataAtom, newBookingWizardData);
  }
);
